import isEmpty from "lodash/isEmpty";
import { FillRoleModal } from "PFApp/audit_planner/parts/modals/fill_role_modal";
import { RequestApprovalModal } from "PFApp/audit_planner/parts/modals/request_approval_modal";
import { Button } from "PFComponents/button";
import { useActivityInvalidate } from "PFCore/hooks/queries/activity";
import { useAuditRolesInvalidate } from "PFCore/hooks/queries/audit_planner/audit_roles/use_audit_roles_invalidate";
import { useShortlistsInvalidate } from "PFCore/hooks/queries/shortlists/use_shortlists_invalidate";
import { fetchPotentialExceptions } from "PFCore/services/audit_planner";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const FillAuditRoleButton = ({ shortlistItem, activity, engagement }) => {
  const { invalidateShortlists } = useShortlistsInvalidate();
  const { invalidateAll: invalidateAuditRoles } = useAuditRolesInvalidate();

  const [exceptionsChecked, setExceptionsChecked] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const canFill =
    !["exception", "booked", "filled", "confirmed"].includes(activity.workflow_state) &&
    activity.state !== "complete";

  const { t } = useTranslation("activities");
  const { invalidate: invalidateActivities } = useActivityInvalidate();

  const onClick = (event) => {
    event.stopPropagation();
    fetchPotentialExceptions({
      activityId: activity.id,
      profileId: shortlistItem.profile.id
    }).then((exceptions) => {
      if (exceptions) {
        setExceptionsChecked(exceptions);
      }
      setShowModal(true);
    });
  };

  const handleSuccess = () => {
    invalidateActivities([activity.id]);
    invalidateShortlists(activity.id);
    invalidateAuditRoles();
  };

  return (
    <>
      <Button
        text={t("show.parts.fillRole")}
        kind="secondary"
        disabled={!canFill}
        onClick={onClick}
        style={{ marginLeft: "auto" }}
      />
      {showModal &&
        (!isEmpty(exceptionsChecked) ? (
          <RequestApprovalModal
            shortlistItem={shortlistItem}
            exception={exceptionsChecked}
            role={activity}
            engagement={engagement}
            onClose={() => setShowModal(false)}
            onSuccess={handleSuccess}
          />
        ) : (
          <FillRoleModal
            shortlistItem={shortlistItem}
            role={activity}
            engagement={engagement}
            onClose={() => setShowModal(false)}
            onSuccess={handleSuccess}
          />
        ))}
    </>
  );
};

FillAuditRoleButton.propTypes = {
  shortlistItem: PropTypes.object.isRequired,
  role: PropTypes.object.isRequired,
  engagement: PropTypes.object.isRequired
};

export default FillAuditRoleButton;
